import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import { useGetSchedulerFunnelProfilesId } from '@/utils/scheduler/funnel/hooks/useGetSchedulerFunnelProfilesId';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import PropTypes from 'prop-types';

import { tabsList } from '@/lib/scheduler/tabs';

import { ButtonFunnelModal } from '@/components/pages/scheduler/SchedulerHeader/ButtonFunnelModal';
import { UnlockSchedulerPermission } from '@/components/pages/scheduler/SchedulerHeader/UnlockSchedulerPermission';
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';

const SchedulerHeader = ({
    isGroup,
    activeGroup,
    activeSocialProfile,
    setNeedReloadScheduledPosts = () => {}
}) => {
    const { t } = useTranslation('scheduler');
    const pathname = usePathname();

    const currentLink = tabsList.find((link) => link.url === pathname);
    const router = useRouter();
    const { deleteQuery } = useRouterQuery();

    const { profilesIdWithPermission, profilesId } = useGetSchedulerFunnelProfilesId({
        activeGroup,
        activeSocialProfile
    });

    useEffect(() => {
        router.replace(deleteQuery('scheduler_permission'), undefined, { shallow: true });
    }, []);

    const displayButtonPermission = profilesIdWithPermission.length !== profilesId.length;

    return (
        <PageHeaderRecap hideStickyHeader title={t(currentLink.label)}>
            {() => {
                return (
                    <div className="hidden w-full items-center justify-end space-x-3 md:flex lg:mt-0 lg:w-auto lg:flex-1">
                        {displayButtonPermission ? (
                            <UnlockSchedulerPermission activeSocialProfile={activeSocialProfile} />
                        ) : null}
                        <ButtonFunnelModal
                            isGroup={isGroup}
                            activeGroup={activeGroup}
                            activeSocialProfile={activeSocialProfile}
                            setNeedReloadScheduledPosts={setNeedReloadScheduledPosts}
                        />
                    </div>
                );
            }}
        </PageHeaderRecap>
    );
};

SchedulerHeader.propTypes = {
    setNeedReloadScheduledPosts: PropTypes.func
};

export default SchedulerHeader;
